var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.6 5.21326L1.34064e-06 0.786903L9.2 0.786904L4.6 5.21326Z","fill":"#00008D"}})])}
var staticRenderFns = []

export { render, staticRenderFns }